import type { Data } from '../+data';

function getSimilarJobsCount(data: Data | null | undefined): number {
  return Array.isArray(data?.similarJobs) ? data.similarJobs.length : -1;
}

function getObjectId(data: Data | null | undefined): string | null {
  const objectId = (data as { job?: { objectID?: unknown } } | null | undefined)?.job?.objectID;
  return objectId == null ? null : String(objectId);
}

function pickBaseData(candidates: Array<Data | null | undefined>): Data | undefined {
  for (const candidate of candidates) {
    if (candidate?.job) return candidate;
  }
  return candidates.find(Boolean) ?? undefined;
}

/**
 * Merges candidate job-detail data sources and prefers the richest similarJobs payload
 * for the same job objectID to avoid SSR/CSR drift during hydration.
 */
export function resolveJobDetailData(candidates: Array<Data | null | undefined>): Data | undefined {
  const base = pickBaseData(candidates);
  if (!base) return undefined;

  const baseObjectId = getObjectId(base);
  const sameJobCandidates = baseObjectId
    ? candidates.filter((candidate) => getObjectId(candidate) === baseObjectId)
    : candidates;

  const richestSimilarJobsSource = sameJobCandidates.reduce<Data | null>((best, current) => {
    if (!current) return best;
    if (!best) return current;
    return getSimilarJobsCount(current) > getSimilarJobsCount(best) ? current : best;
  }, null);

  const similarJobs =
    (richestSimilarJobsSource && Array.isArray(richestSimilarJobsSource.similarJobs))
      ? richestSimilarJobsSource.similarJobs
      : base.similarJobs;

  return {
    ...base,
    similarJobs,
  };
}

